<template>
  <div class="home-trails">
    <router-link
      v-for="trail in list"
      :key="trail.id"
      :to="{
        name: 'trail',
        params: { id: trail.id, slug: slugfy(trail.name) }
      }"
    >
      <div class="img-wrapper mb-3">
        <img :src="trail.picture" />
      </div>

      <span :style="{ color: trail.color }">{{ trail.name }}</span>
    </router-link>
  </div>
</template>

<script>
import { slugfy } from "@/functions/helpers.js";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    slugfy
  }
};
</script>

<style lang="scss" scoped>
.home-trails {
  display: flex;
  justify-content: center;
  gap: 48px;
  flex-wrap: wrap;
  text-align: center;

  @media screen and (max-width: 767px) {
    gap: 24px;
  }

  a {
    transition: all 0.2s;
    max-width: 98px;
    text-decoration: none;

    @media screen and (max-width: 767px) {
      max-width: 72px;
    }

    &:hover {
      transform: scale(1.05);
      filter: brightness(1.2);
    }

    .img-wrapper {
      width: 100%;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    span {
      display: block;
      line-height: 120%;
      font-size: 14px;

      @media screen and (max-width: 991px) and (min-width: 576px) {
        font-size: 12px;
      }

      @media screen and (max-width: 575px) {
        font-size: 10px;
      }
    }
  }
}
</style>
